export const ignoreErrors: string[] = ['Request failed with status code 401', 'Network Error'];
